import React from 'react';

const Cross = ({ className }: { className?: string }) => {
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 36.77 36.77">
			<path
				d="M18.385 16.566 25.96 8.99l1.817 1.818-7.575 7.576 7.576 7.577-1.818 1.819-7.576-7.576-7.576 7.576-1.82-1.82 7.577-7.575-7.576-7.576 1.818-1.818Z"
				fill="#fff"
				stroke="#fff"
				strokeWidth="2"
			/>
		</svg>
	);
};

export default Cross;
